export function getYouTubeVideoId(url) {
  if (!url) return '';
  const liveMatch = url.match(/youtube\.com\/live\/([^?&/]+)/i);
  const shortsMatch = url.match(/shorts\/([^?&/]+)/i);
  const watchMatch = url.match(/[?&]v=([^?&/]+)/i);
  return liveMatch?.[1] || watchMatch?.[1] || shortsMatch?.[1] || '';
}

export function resolveWatchItem(entry, section) {
  if (typeof entry === 'string') {
    const videoId = getYouTubeVideoId(entry);
    return {
      url: entry,
      thumbnail: section.coverSrc || `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
      alt: section.title,
      isPlaylist: false,
    };
  }

  return {
    url: entry.url,
    thumbnail:
      entry.thumbnail ||
      section.coverSrc ||
      `https://img.youtube.com/vi/${getYouTubeVideoId(entry.url)}/hqdefault.jpg`,
    alt: entry.alt || section.title,
    isPlaylist: Boolean(entry.isPlaylist),
  };
}

export function getWatchSectionIndex(contentKey) {
  const match = contentKey?.match(/^watch\.section\.(\d+)\.videos$/);
  return match ? Number(match[1]) : null;
}
